import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/resultCardBasketball.css';
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
import {BASKET_BALL_EURO, HARD_SUSPENDED, MAD, RSD} from "../../../constants/identifiers";
import {ASSETS_URL} from '../../../constants/endpoints';
// helpers
import {roundNumber, roundNumberForCurrency} from "../../../helpers/mathFunctions";
//actions
import {getGameFromChannel} from "../helpers/gameHelpers";
import {MONEYLINE} from '../modules/basketball/constants/marketTypes';
import basketballColorConfig from '../../../constants/configurations/basketballColorConfig.json';
import nbaColorConfig from '../../../constants/configurations/nbacolorconfig.json';
import {getAllWrappedBets} from '../helpers/betHelpers';
import {BASE_VALUE} from "../../../constants/chips";
import {getPotentialReturn} from '../modules/matchday/helpers/matchdayHelper';
import { isNBAEvent } from '../../../helpers/moduleHelpers';


const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedGameIndex: state.vpp.selectedGameIndex,
        systemLanguage: state.vpp.systemLanguage,
        channelEventBets: state.vpp.channelEventBets
    };
};

class ResultCardBasketball extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            systemLanguage: storeData.vpp.systemLanguage,
            channelEventBets: storeData.vpp.channelEventBets
        };
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                events: storeData.vpp.events,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                systemLanguage: storeData.vpp.systemLanguage,
                channelEventBets: storeData.vpp.channelEventBets,
            });
        }
    }

    _isFromEuropeanChannel(event) {
        return event.eventType === BASKET_BALL_EURO;
    }

    render() {
        let game = this.state.games.find((game) => game.channel === this.state.games[this.state.selectedGameIndex].channel && game.lastResult !== undefined);
        if (game !== undefined) {
            let event = this.state.events.find((evt) => evt.eventId === Number(game.lastResult.eventId) && evt.channel === game.lastResult.channel);
            if (event !== undefined) {
                let store = this.props.store;
                let storeData = store.getState();
                let placedBets = getAllWrappedBets(this.state, game.channel);
                let eventActiveBets = [];
                let totalReturns = 0;
                let lookForNextText = '';
                let scheduledEventText = '';
                let returnsText = '';
                let prizeAmount = '';
                let eventResult = game.lastResult.result.split(',');
                let containerStyle = style.middleContainer;
                let matchResultMarket = eventResult.find((result) => {
                    return result.startsWith(MONEYLINE.code)
                });
                let fullTimeResult = eventResult.find((result)=>{
                    return result.startsWith("score")
                })
                let europeFinalScore = fullTimeResult.split("_")[1].split("::").join("-");
                let showFinalSCore = europeFinalScore.includes("null") ? false : true;
                let systemCurrency = this.props.store.getState().vpp.systemCurrency;

                if (placedBets && placedBets.length) {
                    let completeBets = [];
                    // only add the active bets to the array if game isn't hard suspended.
                    // Hard suspension do not pay the bet when settled
                    if (game.state !== HARD_SUSPENDED) {
                        completeBets = placedBets.slice();
                    }

                    eventActiveBets = completeBets.filter((aBet) => {
                        let exists = aBet.Bets.find((bet) => {
                            let eventBetExists = bet.EventId === game.lastResult.eventId && bet.Channel === game.lastResult.channel;
                            return eventBetExists;
                        });
                        return exists !== undefined;
                    });

                    if (eventActiveBets && eventActiveBets.length) {
                        for (let i = 0; i < eventResult.length - 1; i++) {
                            for (let j = 0; j < eventActiveBets.length; j++) {

                                let bet = eventActiveBets[j].Bets[0];
                                if (eventResult[i] === bet.Market.Id) {
                                    let stake = 0;

                                    if (usingNonDecimalCurrency(systemCurrency)) {
                                        stake = roundNumber(bet.Stake, 2);
                                    } else {
                                        stake = roundNumber(bet.Stake / BASE_VALUE, 2);
                                    }
                                    if (Number(stake) && Number(bet.Market.Price)) {
                                        totalReturns = totalReturns + roundNumberForCurrency(getPotentialReturn(bet.Market.Price, stake, 1, 0), systemCurrency);
                                        //promobet logic 
                                        if(!(bet.PromoId === 'real_bet')){
                                            totalReturns = totalReturns - stake;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (totalReturns !== 0) {
                    returnsText = (<div
                        className={systemCurrency === RSD || systemCurrency === MAD ? style.winTextNonSymbolCurrency : style.winText}>{getText('RETURNS', this.props.store)}</div>);
                    prizeAmount = (<div
                        className={systemCurrency === RSD || systemCurrency === MAD ? style.winTextNonSymbolCurrency : style.winText}>{getFormattedCurrency(this.props.store, totalReturns, 2)}</div>);

                } else {
                    lookForNextText = (
                        <div className={style.lookForNextOnly}>{getText('LOOK_FOR_THE_NEXT', this.props.store)}</div>);
                    scheduledEventText = (
                        <div className={style.lookForNextOnly}>{getText('SCHEDULED_EVENT', this.props.store)}</div>);
                    containerStyle = style.middleContainerForNext;
                }

                let awayTeamKit = event.awayTeamKit.toString() === '0'
                    ? '_Home'
                    : '_Away';
                let teamOneJersey;
                let teamTwoJersey;
                let teamOneHomeOrAway;
                let teamTwoHomeOrAway;
                let finalScore;

                if (this._isFromEuropeanChannel(event)) {
                    teamOneJersey = event.teamTwo.split(' ').join('');
                    teamTwoJersey = event.teamOne.split(' ').join('');
                    teamOneHomeOrAway = awayTeamKit;
                    teamTwoHomeOrAway = '_Home';
                    finalScore = europeFinalScore;
                    
                } else {
                    teamOneJersey = event.teamOne.split(' ').join('');
                    teamTwoJersey = event.teamTwo.split(' ').join('');
                    teamOneHomeOrAway = '_Home';
                    teamTwoHomeOrAway = awayTeamKit;
                    finalScore = europeFinalScore.split("-").reverse().join(" - ");
                }


                let home = (
                    <div className={style.teamImage}>
                        <img
                            src={`${ASSETS_URL}${getGameFromChannel(event.channel, storeData.vpp.games).assetsPath}/silks/full/${teamOneJersey}${teamOneHomeOrAway}.png`}
                            className={style.basketballIconRight}
                            alt={`icon_${teamOneJersey}`}/>
                    </div>);

                let away = (
                    <div className={style.teamImage}>
                        <img
                            src={`${ASSETS_URL}${getGameFromChannel(event.channel, storeData.vpp.games).assetsPath}/silks/full/${teamTwoJersey}${teamTwoHomeOrAway}.png`}
                            className={style.basketballIcon}
                            alt={`icon_${teamTwoJersey}`}/>
                    </div>);

                let winTeam;
                let winTeamName;
                let bannerColor;
                let bannerFontColor;
                let colorConfig =  isNBAEvent(event.eventType) ? nbaColorConfig : basketballColorConfig;

                if (matchResultMarket.endsWith('1')) {
                    winTeam = colorConfig.teams.filter((team) => (team.name === event.teamOne));
                    winTeamName = event.teamOne;
                    bannerColor = winTeam.length == 0
                        ? colorConfig.default.home.color
                        : winTeam[0].home.color;
                    bannerFontColor = winTeam.length == 0
                        ? colorConfig.default.home.font
                        : winTeam[0].home.font;
                } else {
                    winTeam = colorConfig.teams.filter((team) => (team.name === event.teamTwo));
                    winTeamName = event.teamTwo;
                    bannerColor = winTeam.length == 0
                        ? colorConfig.default.away.color
                        : event.awayTeamKit.toString() === '0'
                            ? winTeam[0].home.color
                            : winTeam[0].away.color;
                    bannerFontColor = winTeam.length == 0
                        ? colorConfig.default.away.color
                        : event.awayTeamKit.toString() === '0'
                            ? winTeam[0].home.font
                            : winTeam[0].away.font;
                }
                let european = this._isFromEuropeanChannel(event);
                let leftTeamName = european ? event.teamOne : event.teamTwo;
                let rightTeamName = european ? event.teamTwo : event.teamOne;
                let teams = leftTeamName+"_"+rightTeamName;
                
                if(isNBAEvent(event.eventType)){
                    
                    if (matchResultMarket.endsWith('1')) {
                        winTeam = colorConfig.teams.filter((team) => (team.name === teams));
                        winTeamName = event.teamOne;
                        bannerColor = winTeam.length == 0
                            ? colorConfig.default.home.color
                            : winTeam[0].homeBackgroundColour;
                        bannerFontColor = winTeam.length == 0
                            ? colorConfig.default.home.font
                            : winTeam[0].homeForegroundColour;
                    } else {
                        winTeam = colorConfig.teams.filter((team) => (team.name === teams));
                        winTeamName = event.teamTwo;
                        bannerColor = winTeam.length == 0
                            ? colorConfig.default.away.color
                            : winTeam[0].awayBackgroundColour;
                        bannerFontColor = winTeam.length == 0
                            ? colorConfig.default.away.color
                            :winTeam[0].awayForegroundColour;
                    }

                }



                return (
                    <div className={style.mainContainer}>
                        <div className={style.leftContainer}>
                            {away}
                        </div>
                        <div className={style.gameTitleHeader}>
                            <div className={style.gameTitleBannerFirstTeam}
                                 style={{ color: bannerFontColor, backgroundColor: bannerColor,background:`linear-gradient( to left,
                                                                     rgba(255, 255, 255, 0) 0%,
                                                                     ${bannerColor} 30%,
                                                                     ${bannerColor} 70%,
                                                                     rgba(255, 255, 255, 0) 100%)` }}>
                                <div
                                    className={style.gameTitleBannerWinTeam}>{`${getText(winTeamName, this.props.store)}`}</div>
                                 {showFinalSCore ? <div
                                    className={style.gameTitleBannertext}>{finalScore}</div> :<div
                                    className={style.gameTitleBannertext}>{`${getText('WINS_THE_GAME', this.props.store)}`}</div>}

                            </div>
                        </div>
                        <div className={`${containerStyle}`}>
                            {lookForNextText}
                            {scheduledEventText}
                            {returnsText}
                            {prizeAmount}
                        </div>
                        <div className={style.rightContainer}>
                            {home}
                        </div>
                    </div>

                );
            } else {
                return '';
            }
        } else {
            return '';
        }
    }
}

export default connect(mapStateToProps)(ResultCardBasketball);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/resultCardBasketball.js